var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgOther(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#B1CAD8",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.42 21.846l-1.73-.86a.444.444 0 01-.25-.405v-2.906a.456.456 0 00-.129-.319.435.435 0 00-.622 0 .456.456 0 00-.129.319v2.906a.458.458 0 01-.249.405l-2.785 1.378a.447.447 0 00-.22.254.46.46 0 00.016.338.451.451 0 00.252.244.432.432 0 00.346-.018l2.695-1.351a.865.865 0 01.768 0l1.65.82a.432.432 0 00.59-.21.46.46 0 00.017-.34.447.447 0 00-.22-.255z",
    fill: "#7C97A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.412 21.943l-4.607 2.252-1.809-.883-2.059-1.009-.737-.357c.12-.185.285-.333.48-.428l1.117-.545.396-.196.528-.257.922-.45.66-.317a1.155 1.155 0 01.992 0h.018l1.05.51 2.056 1.003.509.25c.197.093.364.241.484.427z",
    fill: "#DCE8ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.612 22.615v4.409c0 .223-.06.443-.174.634a1.197 1.197 0 01-.473.448l-.033.016-3.614 1.76h-.027c-.153.071-.319.107-.486.106v-5.801l4.607-2.252c.133.2.203.438.2.68z",
    fill: "#9BB0B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.805 24.186V30a1.17 1.17 0 01-.502-.115L9.68 28.122a1.2 1.2 0 01-.495-.45 1.239 1.239 0 01-.185-.65v-4.407c-.002-.24.068-.476.2-.675l4.605 2.246z",
    fill: "#BFD0D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.786 23.693h2.037l-1.018 1.423-1.019-1.423z",
    fill: "#EDF4F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 21.943l-4.605 2.252-1.81-.883-2.06-1.008-.737-.358c.12-.185.287-.333.482-.428l1.116-.545.398-.196.528-.256.922-.45.66-.318a1.158 1.158 0 01.994 0h.015l1.05.51 2.059 1.005.51.25c.195.094.36.241.478.425z",
    fill: "#DCE8ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 22.615v4.409c0 .223-.06.443-.173.634a1.199 1.199 0 01-.472.448l-.032.016-3.617 1.76h-.027c-.152.07-.317.107-.484.106v-5.801l4.605-2.252c.133.2.203.438.2.68z",
    fill: "#9BB0B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.195 24.186V30a1.17 1.17 0 01-.504-.115l-3.62-1.762a1.197 1.197 0 01-.496-.448 1.237 1.237 0 01-.185-.649v-4.41c-.002-.24.068-.476.2-.675l4.605 2.246z",
    fill: "#BFD0D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.177 23.693h2.035l-1.017 1.423-1.018-1.423z",
    fill: "#EDF4F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.607 11.305L20 13.547l-1.808-.88-2.062-1.002-.737-.358c.12-.184.287-.332.482-.428l1.118-.545.396-.193.528-.26.921-.45.66-.317a1.154 1.154 0 01.993 0h.017l1.047.511 2.06 1.002.508.25c.197.094.364.242.484.428z",
    fill: "#DCE8ED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.805 11.975v4.408c0 .224-.06.443-.174.634a1.2 1.2 0 01-.47.449l-.034.015-3.614 1.761h-.027c-.152.072-.318.11-.486.113v-5.809l4.607-2.251c.131.201.2.438.198.68z",
    fill: "#9BB0B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.548v5.808c-.173 0-.345-.04-.502-.115l-3.623-1.758a1.196 1.196 0 01-.494-.448 1.235 1.235 0 01-.184-.649v-4.41a1.22 1.22 0 01.199-.675L20 13.548z",
    fill: "#BFD0D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.981 13.05h2.038L20 14.479l-1.019-1.427z",
    fill: "#EDF4F7"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h22v21H0z"
  })))));
}
export default SvgOther;